export default Object.freeze({
  RejectParallelFlow: 'reject-parallel-flow',
  RejectParallel: 'reject-parallel',
  RejectProcessInstance: 'reject-process-instance',
});
